import React from "react";
import {NavLink} from "react-router-dom";

const MyCardItem = ({item, nft_name, bg}) => {
    const {title, landPlot, active} = item;
    return (
        <div
            className="w-full h-320 flex flex-col justify-between py-4 px-6 rounded-xl overlay-card relative"
            style={{
                backgroundImage: `url(${bg})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center center',
                backgroundRepeat: 'no-repeat'
            }}
        >
            <div className="mt-5 z-1">
                <h3 className="text-white mb-0 text-3xl font-bold mb-5">{nft_name}</h3>
                <div className="flex items-center gap-x-2">
                    <i className="icon-pin text-xl text-pink-400"></i>
                    <span className="text-xl">Metafluence City</span>
                </div>
            </div>
            <div className="flex items-center justify-between gap-x-1 flex-wrap z-1">
                <div className="flex items-center gap-x-2">
                    {/*<span className="text-cyan-500 text-base">https://metafluence.com/camillahut</span>
                    <i className="icon-copy text-xl text-cyan-500"></i>*/}
                </div>
                <div className="flex items-center gap-x-2">
                    {0 && active ? <span className="text-green-500 uppercase font-medium">active</span> : ''}
                    <i className="icon-settings text-2xl text-white"></i>
                </div>
            </div>
        </div>
    )
}

export default MyCardItem;